import { createRouter, createWebHistory } from "vue-router";
import QuoteView from "../views/QuoteView.vue";
import SiteView from "../views/SiteView.vue";
import BuilderView from "../views/BuilderView.vue";
import BuilderView2 from "../views/BuilderView2.vue";
import BuilderView3 from "../views/BuilderView3.vue";
import LeadsView from "../views/LeadsView.vue";
import JobsView from "../views/JobsView.vue";
import ContactsView from "../views/ContactsView.vue";
import CustomerProfileView from "../views/CustomerProfileView.vue";
import HomeView from "../views/HomeView.vue";
import QuotePreviewView from "../views/QuotePreviewView.vue";
import cmsView from "../views/cmsView.vue";
import SettingsView from "../views/SettingsView.vue";
import DomainView from "../views/DomainView.vue";
import EmailView from "../views/EmailView.vue";
import SitePreviewView from "../views/SitePreviewView.vue";
import PreviewSiteView from "../views/PreviewSiteView.vue";
import AdminView from "../views/AdminView.vue";
import DigitalMarketingView from "../views/marketing/DigitalMarketingView.vue";
import PhysicalMarketingView from "../views/marketing/PhysicalMarketingView.vue";
import ReputationView from "../views/marketing/ReputationView.vue";
import CampaignsView from "../views/marketing/CampaignsView.vue";

import { watch } from 'vue'
import { isAdmin, authResolved, isDevUser } from '@/stores/appConfig'
 
 

function waitForAuth() {
  if (authResolved.value) return Promise.resolve()
  return new Promise(resolve => {
    const stop = watch(authResolved, (val) => {
      if (val) { stop(); resolve() }
    }, { immediate: true })
  })
}

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/quote",
    name: "quote",
    component: QuoteView,
    meta: { devOnly: true },
  },
  {
    path: "/quote-preview/:quoteNumber?",
    name: "quote-preview",
    component: QuotePreviewView,
    meta: { public: true },
  },
  {
    path: "/cms",
    name: "cms",
    component: cmsView,
  },

  {
    path: "/site/:id",
    name: "site",
    component: SiteView,
        meta: { public: true },
  },

  {
    path: "/site-preview/:id",
    name: "site-preview",
    component: SitePreviewView,
        meta: { public: true },
  },

  {
    path: "/preview/:token",
    name: "preview",
    component: PreviewSiteView,
        meta: { public: true },
  },


  {
    path: "/cms/domain",
    name: "domain",
    component: DomainView,
  },

  {
    path: "/cms/email",
    name: "email",
    component: EmailView,
  },


    
  {
    path: "/cms/builder",
    name: "builder",
    component: BuilderView,
  },

  {
    path: "/cms/builder2",
    name: "builder2",
    component: BuilderView2,
  },

  {
    path: "/cms/builder3",
    name: "builder3",
    component: BuilderView3,
  },

  {
    path: "/jobs",
    name: "jobs",
    component: JobsView,
  },

  {
    path: "/crm",
    redirect: "/crm/leads",
  },

  {
    path: "/crm/leads",
    name: "crm-leads",
    component: LeadsView,
  },

  {
    path: "/crm/contacts",
    name: "crm-contacts",
    component: ContactsView,
  },

  {
    path: "/crm/customers/:id",
    name: "crm-customer-profile",
    component: CustomerProfileView,
  },

  {
    path: "/marketing",
    redirect: "/marketing/digital",
  },

  {
    path: "/marketing/digital",
    name: "marketing-digital",
    component: DigitalMarketingView,
    meta: { devOnly: true },
  },

  {
    path: "/marketing/physical",
    name: "marketing-physical",
    component: PhysicalMarketingView,
    meta: { devOnly: true },
  },

  {
    path: "/marketing/reputation",
    name: "marketing-reputation",
    component: ReputationView,
    meta: { devOnly: true },
  },

  {
    path: "/marketing/campaigns",
    name: "marketing-campaigns",
    component: CampaignsView,
    meta: { devOnly: true },
  },


  {
    path: "/settings",
    name: "settings",
    component: SettingsView,
  },

  {
    path: "/admin",
    name: "admin",
    component: AdminView,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },

 
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    const el = document.querySelector(".content");
    if (el) el.scrollTop = 0;
  },
});

/*
router.beforeEach(async (to) => {
  if (to.path.startsWith('/admin')) {
    await waitForAuth()
    if (!isAdmin.value) return '/'
  }
})*/


router.beforeEach(async (to) => {
  if (to.meta?.public) {
    return
  }

  if (to.meta?.devOnly) {
    await waitForAuth()
    if (!isDevUser.value && !isAdmin.value) return '/'
  }

  if (to.path.startsWith('/admin')) {
    await waitForAuth()
    if (!isAdmin.value) return '/'
  }
})

export default router;
